import React from 'react';
import Grid from '@material-ui/core/Grid';
import { useStyle } from './Style';
import LoginForm from '../LoginForm/LoginForm';
import Footer from '../Footer/Footer';
import LogoTop from '../../../../../../Assets/LOGO TOP.png';

function Hero(props) {
  const classes = useStyle();

  return (
    <div className={classes.heroRoot}>
      <img src={LogoTop} alt="Old Mutual" className={classes.logoTop} />
      <div className={classes.heroContent}>
        <Grid container>
          <Grid item xs={12} md={6}>
            <div className={classes.brandSide}>
              <h1 className={classes.tagline}>
                Insurance solutions<br />built for Africa
              </h1>
              <hr className={classes.divider} />
              <p className={classes.subTagline}>
                Seamlessly manage policies, claims and payments
                through a single, powerful platform — designed
                for emerging markets.
              </p>
            </div>
          </Grid>
          <Grid item xs={12} md={6}>
            <div className={classes.formSide}>
              <LoginForm
                login={props.login}
                loading={props.loading}
                loginError={props.loginError}
                mfaPending={props.mfaPending}
                pendingAuthToken={props.pendingAuthToken}
                maskedEmail={props.maskedEmail}
                mfaLoading={props.mfaLoading}
                mfaError={props.mfaError}
                mfaResent={props.mfaResent}
                onVerify={props.onVerify}
                onResend={props.onResend}
                onCancel={props.onCancel}
                forgetpassword={props.forgetpassword}
                language={props.language}
                updateGlobalLanguage={props.updateGlobalLanguage}
                labels={props.labels}
              />
            </div>
          </Grid>
        </Grid>
      </div>
      <Footer />
    </div>
  );
}

export default Hero;
